export default class GlobalDispatcher {
    static get listeners() {
        if (!this._listeners) {
            this._listeners = [];
        }
        return this._listeners;
    }

    static get eventsStack() {
        if (!this._eventsStack) {
            this._eventsStack = [];
        }
        return this._eventsStack;
    }

    static set inProgress(value) {
        this._inProgress = value;
    }

    static get inProgress() {
        if (!this._inProgress) {
            this._inProgress = false;
        }
        return this._inProgress;
    }

    static add($event, $callback, $context, $priority) {
        let listener = {event: $event, callback: $callback, context: $context, priority: $priority || 1, once: false};
        this.addToListeners(listener);
    }

    static addOnce($event, $callback, $context, $priority) {
        let listener = {event: $event, callback: $callback, context: $context, priority: $priority || 1, once: true};
        this.addToListeners(listener);
    }

    static addToListeners($listener) {
        this._listeners = [ ...this.listeners, $listener ].sort(function (a, b) {
            return b.priority - a.priority;
        });
    }

    static dispatch($event, $params) {
        this.eventsStack.push({event: $event, params: $params});
        if (!this.inProgress) {
            this.executeFromStack();
        }
    }

    static remove($event, $callback, $context) {
        this._listeners = this.listeners.filter(listener=> !(listener.event === $event && listener.callback === $callback && listener.context === $context))
    }

    static removeAll($event) {
        this._listeners = this.listeners.filter(listener=> listener.event !== $event);
    }

    static _removeListener($listener) {
        this._listeners = this.listeners.filter(listener=> listener !== $listener);
    }

    static executeFromStack() {
        this.inProgress = true;
        let object = null;
        while (this.eventsStack.length > 0) {
            object = this.eventsStack.shift();
            this.execute(object.event, object.params);
        }
        this.inProgress = false;
    }

    static execute($event, $params) {
        let param = null;
        this.listeners.forEach((listener) => {
            if (this.listeners.includes(listener) && listener.event === $event) { // this.listeners.includes(listener) because the listener can be removed during iteration
                param = {type: $event, params: $params};
                if (listener.context) {
                    listener.callback.call(listener.context, param);
                } else {
                    listener.callback(param);
                }
                if (listener.once) {
                    this._removeListener(listener);
                }
            }
        });
    }
}
